










import { Component, Mixins } from "vue-property-decorator";
import { DeveloperPresentableMixin } from "./mixins";

@Component
export default class DeveloperIndicator extends Mixins(DeveloperPresentableMixin) {
  open(): void {
    this.$commonDialogs.developer.editor.show();
  }
}
